import { apiGet, apiPatch } from './client';
import type { Idx, IdxBatchRequest } from '../types/Idx';

export function getIndices(): Promise<Idx[]> {
  return apiGet<Idx[]>('/api/idx');
}

export function saveIdxBatch(
  added: Idx[],
  modified: Idx[],
  deletedIds: number[],
): Promise<Idx[]> {
  return apiPatch<IdxBatchRequest, Idx[]>('/api/idx/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
